<template>
  <customModal 
    :containersm="true" 
    :footerShow="false" 
    @closeModal="closeModal"
  >
    <template #title>
      <h4 class="my-0">
        {{ "Manage ICF Videos" }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
          <div class="mb-1">
            <div class="me-3 d-flex justify-content-end align-items-center" v-if="rollsprivilages.includes('ICF Upload Videos')">
              <div class="position-relative">
                   <img 
                            width="17" 
                            height="17" 
                            class="cursor-pointer" 
                            src="../../assets/img/upload.png"
                            alt="Upload editcheck"
                            @click.prevent="openUploadModal"
                        />
                <div class="tool-tip">{{ $t("navigations.upload video") }}</div>
              </div>
            </div>
          </div>

          <!-- Videos Grid -->
            <div class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th>{{ $t("navigations.video title") }}</th>
                    <th>{{ $t("navigations.filename") }}</th>
                    <th class="text-center">{{ $t("navigations.delete") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="showLoading">
                    <td colspan="3" class="text-center">
                      <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
                      {{ $t("navigations.loading") }}
                    </td>
                  </tr>
                  <tr v-else-if="videoList.length === 0">
                    <td colspan="3" class="text-center">
                      {{ $t("navigations.no videos uploaded") }}
                    </td>
                  </tr>
                  <tr v-for="video in videoList" :key="video.id">
                    <td>{{ video.videoTitle || '-' }}</td>
                    <td>{{ video.fileName || video.originalFileName || '-' }}</td>
                    <td class="text-center">
                      <i
                        class="fa fa-trash edit-delete"
                        @click.prevent="deleteVideo(video.id)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        
        </div>
      </div>
    </template>
  </customModal>

  <!-- Upload Video Popup -->
  <customModal 
    v-if="showUploadPopup"
    :containersm="true" 
    :footerShow="false"
    @closeModal="closeUploadModal"
  >
    <template #title>
      <span>{{ $t("navigations.upload video") }}</span>
    </template>

    <template #body>
      <div>
        <div class="row">
          <!-- Title Field -->
          <div class="col-12 mt-2">
            <label for="video-title">Title</label>
            <input
              id="video-title"
              type="text"
              class="form-control"
              maxlength="100"
              v-model.trim="videoTitle"
              placeholder="Enter video title"
            />
            <span class="d-block errorClass" v-if="errors.title">
              Please enter a title
            </span>
          </div>

          <!-- Description Field -->
          <div class="col-12 mt-2">
            <label for="video-description">Description</label>
            <textarea
              id="video-description"
              class="form-control"
              maxlength="500"
              v-model.trim="videoDescription"
              placeholder="Enter description (optional)"
              rows="3"
            ></textarea>
          </div>

          <!-- File Upload Section (No Label) -->
          <div class="col-12 mt-2">
            <input
              ref="videoFileInput"
              id="upload-video-input"
              type="file"
              class="form-control d-none"
              accept="video/mp4,video/webm,video/ogg,.mp4,.webm,.ogg"
              @change="previewVideo"
            />
            
            <!-- Selected File Display -->
            <div v-if="selectedFile" class="input-group mt-2">
              <div class="listfile breakWord">
                <a>
                  {{ selectedFile.name }}
                  <i class="fa fa-close" @click.prevent="removeFile"></i>
                </a>
              </div>
            </div>
            
            <span class="errorClass" v-if="errors.file">
              Please select a video file
            </span>
            <span class="errorClass" v-if="errors.fileType">
              Please upload a valid video file (MP4, WebM, OGG)
            </span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end mt-3">
          <button
            class="browser-btn py-1 px-3 mr-2"
            type="button"
            @click="browseVideo"
          >
            <p class="mb-0">{{ $t("navigations.browse") }}</p>
          </button>

          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingUpload"
            :class="{ 'disabled-btn-cls': loadingUpload }"
            @click="submitVideoUpload"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': !loadingUpload,
                'opacity-1': loadingUpload,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Uploading"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': !loadingUpload,
                'opacity-0': loadingUpload,
              }"
            >
              {{ $t("navigations.upload") }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./ICFVideos.js"></script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}



.edit-delete:hover {
  color: #c0392b;
}

.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.position-relative img {
  width: 20px;
}

.position-relative {
  position: relative;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.3rem 0.8rem;
  right: 20px;
  top: -20px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.ibox-content {
  margin-top: 0;
}

.table th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.table td {
  vertical-align: middle;
}

.browser-btn {
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
  cursor: pointer;
}

.browser-btn:hover {
  background-color: #d4d4d4;
}

.errorClass {
  color: #d9534f;
  font-size: 0.85rem;
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}

.disabled-btn-cls {
  opacity: 0.6;
  cursor: not-allowed;
}

.listfile {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 5px;
}

.listfile a {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.breakWord {
  word-break: break-all;
}
</style>